<template>
  <div
    id="press-releases"
    class="mb-5"
    data-aos="fade-in"
    data-aos-easing="ease-in-out"
    data-aos-duration="1000"
    v-if="featuredPressReleases.length >= 1"
  >
    <Title class="mb-5" text="Featured Press Releases" />

    <div v-for="file in featuredPressReleases" :key="file.id">
      <FeaturedPressRelease :identifier="file.id" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Title from "../Title.vue";
import FeaturedPressRelease from "./FeaturedPressRelease";

export default {
  name: "FeaturedPressReleases",

  components: {
    Title,
    FeaturedPressRelease,
  },

  computed: {
    ...mapGetters(["featured", "pressReleasesID"]),

    featuredPressReleases() {
      return this.featured(this.pressReleasesID.directoryKey);
    },
  },
};
</script>

